import { Trophy, RotateCcw, Home as HomeIcon, Crown, Zap } from "lucide-react";
import { useT } from "../lib/i18n";
import { LegalFooter } from "./LegalFooter";

export default function Scoreboard({ room, playerId, actions }) {
  const { t } = useT();
  const isHost = playerId === room.host_id;

  // Nowe sortowanie bazujące na czasie (FCFS) i ruchach (Podium)
  const ranked = [...room.players].sort((a, b) => {
    if (room.mode === "fcfs") {
        const avgA = a.moves ? (a.total_time || 0) / a.moves : 999;
        const avgB = b.moves ? (b.total_time || 0) / b.moves : 999;
        return avgA - avgB; // Wygrywa najkrótszy średni czas
    } else {
        if (b.score !== a.score) return (b.score || 0) - (a.score || 0);
        return (a.moves || 0) - (b.moves || 0); // Wygrywa mniejsza liczba ruchów przy remisie
    }
  });
  
  const winner = ranked[0];
  const medals = ["🥇", "🥈", "🥉"];

  return (
    <div className="grain relative min-h-screen flex flex-col overflow-hidden bg-[#050510]">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[400px] rounded-full bg-[#FFE800] opacity-15 blur-[120px]" />
      
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 max-w-2xl mx-auto w-full relative z-10">
        <div className="w-full text-center">
          <Trophy size={56} className="mx-auto text-[#FFE800] mb-4" />
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-2">{t("game_over")}</h1>
          {winner && (
            <p className="text-lg text-[#A0A0B0] mb-2">
              <span className="text-[#FFE800] font-bold">{winner.name}</span> {t("wins")}
            </p>
          )}
          <p className="text-xs font-mono2 tracking-widest text-[#505060] uppercase mb-10">
            {room.mode === "podium" ? t("podium_mode") : t("fcfs_mode")}
          </p>

          <div data-testid="scoreboard-list" className="space-y-3 mb-10">
            {ranked.map((p, i) => {
              // Obliczanie naszych nowych statystyk
              const moves = p.moves || 0;
              const avgTime = moves > 0 ? ((p.total_time || 0) / moves).toFixed(1) : "0.0";
              
              return (
                <div
                  key={p.id}
                  data-testid="scoreboard-row"
                  className={`flex items-center gap-4 p-4 rounded-2xl border-2 ${
                    i === 0 ? "border-[#FFE800] bg-[#FFE800]/10 hard-shadow-yellow" : "border-white/10 bg-[#12121A]"
                  }`}
                >
                  <span className="text-2xl w-8">{medals[i] || i + 1}</span>
                  <div className="w-10 h-10 rounded-full flex items-center justify-center font-display font-black text-[#050510]" style={{ backgroundColor: p.color }}>
                    {p.name.charAt(0).toUpperCase()}
                  </div>
                  <div className="text-left flex-1">
                    <div className="font-bold text-lg">{p.name}</div>
                    
                    {/* Tutaj podmieniliśmy "odgadnięto X kart" na liczbę ruchów */}
                    <div className="text-xs text-[#A0A0B0] flex items-center gap-1 mt-0.5">
                      <Zap size={12} className={i === 0 ? "text-[#FFE800]" : "text-[#A0A0B0]"} /> 
                      {moves} {t("moves") || "ruchów"}
                    </div>
                  </div>
                  
                  {i === 0 && <Crown size={20} className="text-[#FFE800]" />}
                  
                  {/* Duży wynik po prawej: Średni czas (FCFS) albo Punkty (Podium) */}
                  <span className="font-display text-2xl font-black" style={{ color: p.color }}>
                    {room.mode === "fcfs" ? `${avgTime}s` : (p.score || 0)}
                  </span>
                </div>
              );
            })}
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            {isHost && (
              <button data-testid="play-again-button" onClick={actions.restart} className="flex-1 min-h-[64px] rounded-2xl bg-[#00FF66] text-[#050510] font-display font-black text-lg flex items-center justify-center gap-2 transition-transform duration-150 hover:-translate-y-1 hard-shadow-white">
                <RotateCcw size={22} /> {t("play_again")}
              </button>
            )}
            <button data-testid="leave-button" onClick={actions.leave} className="flex-1 min-h-[64px] rounded-2xl border-2 border-white/15 font-display font-bold text-lg flex items-center justify-center gap-2 hover:bg-white/5 transition-colors">
              <HomeIcon size={22} /> {t("leave")}
            </button>
          </div>
          {!isHost && <p className="text-sm text-[#505060] mt-4 glow-pulse font-mono2">{t("waiting_restart")}</p>}
        </div>
      </div>
      
      <div className="w-full z-20 relative">
        <LegalFooter screen="WYNIKI" />
      </div>
    </div>
  );
}